import { redirect } from 'react-router-dom';
import { createSession } from '../../store/actions/sessionActions';
import { resetError } from '../../store/actions/errorActions';
import { getMainHubConfigs } from '../../store/actions/mainHubActions';
import { httpGet } from '../../store/externalCalls/httpCalls';
import store from '../../store/store';

const normalize = (value) => (value || '').trim().toLowerCase();

export const mainHubLoader = async ({ request }) => {
  const dispatch = store.dispatch;
  const currentSession = store.getState()?.session || {};

  try {
    dispatch(resetError());

    const url = new URL(request.url);
    const pathname = url.pathname;
    const response = await httpGet(`loader?path=${encodeURIComponent(pathname)}`);

    if (response?.redirectTo) {
      return redirect(response.redirectTo);
    }

    const mainHub = response?.mainHub ?? null;
    const configs = Array.isArray(response?.configs) ? response.configs : [];
    const sportRoom = response?.sportRoom ?? null;
    const spaces = Array.isArray(response?.spaces) ? response.spaces : [];
    const spaceName = response?.spaceName ?? null;
    const params = response?.params ?? {};

    const mainHubSlugName = params?.mainHubSlugName ?? mainHub?.slug ?? null;
    const spaceSlugName = params?.spaceSlugName ?? null;
    const contentSlugName = params?.contentSlugName ?? null;
    const configSlugName = params?.configSlugName ?? null;

    if (!mainHub?.id || !mainHubSlugName) {
      return redirect('/wlpro');
    }

    const mainHubId = parseInt(mainHub.id, 10);
    dispatch(createSession({
      configId: undefined,
      configSlug: undefined,
      mainhubConfigName: '',
      mainHubSlugName,
      mainHubId,
      ...(mainHub.name !== undefined ? { mainHubName: mainHub.name } : {}),
    }));

    dispatch(getMainHubConfigs(configs));
    dispatch(createSession({ configs }));

    const sessionConfigId = currentSession.configId;
    let validSessionConfig =
      configs.find((config) => String(config.name) === String(configSlugName)) ||
      configs.find((config) => String(config.id) === String(sessionConfigId)) ||
      null;

    if (!validSessionConfig && configs.length > 0) {
      validSessionConfig = configs[0];
    }

    if (validSessionConfig) {
      dispatch(createSession({
        configId: validSessionConfig.id,
        configSlug: validSessionConfig.name,
        mainhubConfigName: validSessionConfig.name,
        mainHubId
      }));
    } else {
      dispatch(createSession({
        configId: undefined,
        configSlug: undefined,
        mainhubConfigName: '',
      }));
    }

    let sportRoomId = null;
    let appConfigs = [];
    let matchedAreaId = null;
    let selectedMainHubConfig = validSessionConfig;

    if (sportRoom?.id) {
      sportRoomId = parseInt(sportRoom.id, 10);

      const currentSpace = spaces.find(
        (space) => String(space.id) === String(sportRoom.id)
      );

      appConfigs = Array.isArray(currentSpace?.appConfigs) ? currentSpace.appConfigs : [];

      if (
        selectedMainHubConfig &&
        configs.length > 0 &&
        appConfigs.length > 0
      ) {
        const matchedArea = appConfigs.find(
          (area) => normalize(area.name) === normalize(selectedMainHubConfig.name)
        );

        if (matchedArea?.id !== undefined) {
          matchedAreaId = parseInt(matchedArea.id, 10);
        }
      }

      dispatch(createSession({
        spaceName: spaceName ?? sportRoom.slug,
        sportRoomId,
        appId: sportRoomId,
        mainHubId,
        configName: selectedMainHubConfig?.name ?? '',
        ...(matchedAreaId !== null ? { areaId: matchedAreaId } : {}),
      }));
    }

    const hasSpaces = spaces.length > 0;
    const hasConfigs = configs.length > 0;
    if (response?.notFound) {
      const mainHub = response?.mainHub ?? null;
      const configs = Array.isArray(response?.configs) ? response.configs : [];
      const sportRoom = response?.sportRoom ?? null;
      const spaces = Array.isArray(response?.spaces) ? response.spaces : [];
      const spaceName = response?.spaceName ?? null;
      const params = response?.params ?? {};

      const mainHubSlugName = params?.mainHubSlugName ?? mainHub?.slug ?? null;
      const spaceSlugName = params?.spaceSlugName ?? sportRoom?.slug ?? null;
      const configSlugName = params?.configSlugName ?? null;

      return {
        notFound: true,
        mainHub,
        mainHubId: mainHub?.id ? parseInt(mainHub.id, 10) : null,
        mainHubSlugName,
        slug: mainHubSlugName,
        configs,
        mainHubConfigId: null,
        sportRoom,
        sportRoomId: sportRoom?.id ? parseInt(sportRoom.id, 10) : null,
        spaces,
        spaceName,
        appConfigs: sportRoom?.appConfigs ?? [],
        areaId: null,
        configName: params?.configName ?? '',
        spaceSlugName,
        contentSlugName: params?.contentSlugName ?? null,
        configSlugName,
        hasSpaces: spaces.length > 0,
        hasConfigs: configs.length > 0,
        missingSpace: false,
        missingConfigs: false,
      };
    }
    return {
      mainHub,
      mainHubId,
      mainHubSlugName,
      slug: mainHubSlugName,
      configs,
      mainHubConfigId: validSessionConfig?.id ?? null,
      sportRoom,
      sportRoomId,
      appConfigs,
      spaces,
      spaceName,
      areaId: matchedAreaId,
      configName: selectedMainHubConfig?.name ?? '',
      spaceSlugName,
      contentSlugName,
      configSlugName: configSlugName,
      hasSpaces,
      hasConfigs,
      missingSpace: !hasSpaces,
      missingConfigs: hasSpaces && !hasConfigs,
    };
  } catch (error) {
    return redirect('/wlpro');
  }
};